import { render, staticRenderFns } from "./CodingPage.vue?vue&type=template&id=6a56bd2f&scoped=true&"
import script from "./CodingPage.vue?vue&type=script&lang=js&"
export * from "./CodingPage.vue?vue&type=script&lang=js&"
import style0 from "./CodingPage.vue?vue&type=style&index=0&id=6a56bd2f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a56bd2f",
  null
  
)

export default component.exports